if(document.querySelector(".js-accordion-item") != null) {
    const accordionItem = document.querySelectorAll(".js-accordion-item");
    accordionItem.forEach((item,index)=>{
        let header = item.querySelector(".js-accordion-button");
        console.log(header)

        header.addEventListener("click", function() {
            item.classList.toggle("active");

            let description = item.querySelector(".js-accordion-content");
            if(item.classList.contains("active")){
                description.style.height=`${description.scrollHeight + 5}px`;
            }else{
                description.style.height = "0px";
            }
        })
    })

    window.addEventListener('load', () => {
        accordionItem.forEach((item) => {
            let accordionItemContent = item.querySelector('.js-accordion-content');
            if(accordionItemContent.innerHTML == 0){
                item.classList.remove('active');
            }
        })
    });

}

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = "_blank";
        links[i].rel = "noreferrer noopener";
    }
}